"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseInitialisation = void 0;
/**
 * initialisationData is an object that contains the initial replications (target must be an internalTarget of value base, healthdata or patient) and the users and healthcare parties to be created
 */
class DatabaseInitialisation {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.DatabaseInitialisation = DatabaseInitialisation;
//# sourceMappingURL=DatabaseInitialisation.js.map